import React, { useState, useEffect } from 'react';
import GradientColorPicker, { useColorPicker } from 'react-best-gradient-color-picker';
import { mdiRotateRight, mdiFlipHorizontal } from '@mdi/js';
import {getRandomColor} from '../utils/colorUtils'
const ColorPicker = ({ value, onChange, onClose }) => {
  const initialColor = typeof value === 'string' ? value : getRandomColor();
  const [color, setColor] = useState(initialColor);
  const [colorType, setColorType] = useState(
    value?.includes('gradient') ? 'gradient' : 'solid'
  );
  const { setSolid, setGradient } = useColorPicker(initialColor, setColor);
  useEffect(() => {
  const labelDiv = document.querySelector('#rbgcp-A-input-wrapper > div');
  if (labelDiv) labelDiv.textContent = 'Alpha';

  const linearBtn = document.getElementById('rbgcp-linear-btn');
  if (linearBtn) linearBtn.innerHTML = '<div>linear</div>';

  const radialBtn = document.getElementById('rbgcp-radial-btn');
  if (radialBtn) radialBtn.innerHTML = '<div>radial</div>';

  if (colorType === 'gradient' && typeof color === 'string') {
    updateGradientTypeUI(color);
  }

  const degreeWrapper = document.getElementById('rbgcp-degree-input-wrapper');

  if (
    degreeWrapper &&
    colorType === 'gradient' &&
    color.startsWith('linear-gradient')
  ) {
    // Clear all existing children
    degreeWrapper.innerHTML = '';

    // Button container
    const buttonWrapper = document.createElement('div');
    buttonWrapper.style.display = 'flex';

    // Rotate Button
    const rotateBtn = document.createElement('button');
    rotateBtn.title = 'Rotate +90°';
    rotateBtn.style.cursor = 'pointer';
    rotateBtn.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
        <path d="${mdiRotateRight}" />
      </svg>
    `;
    rotateBtn.onclick = () => {
      const newColor = rotateGradient(color, 90);
      setColor(newColor);
       if (onChange)  onChange(newColor);
    };

    // Flip Button
    const flipBtn = document.createElement('button');
    flipBtn.title = 'Flip +180°';
    flipBtn.style.cursor = 'pointer';
    flipBtn.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
        <path d="${mdiFlipHorizontal}" />
      </svg>
    `;
    flipBtn.onclick = () => {
      const newColor = rotateGradient(color, 180);
      setColor(newColor);
      if (onChange) onChange(newColor);
    };

    buttonWrapper.appendChild(rotateBtn);
    buttonWrapper.appendChild(flipBtn);
    degreeWrapper.appendChild(buttonWrapper);
  }
}, [color, colorType]);

const updateGradientTypeUI = (gradient) => {
  const linearBtn = document.getElementById('rbgcp-linear-btn');
  const radialBtn = document.getElementById('rbgcp-radial-btn');

  if (!linearBtn || !radialBtn) return;

  const isLinear = gradient.startsWith('linear-gradient');
  const isRadial = gradient.startsWith('radial-gradient');

  // Reset styles
  [linearBtn, radialBtn].forEach(btn => {
    btn.style.background = '';
    btn.style.color = '';
  });

  // Apply active styles
  if (isLinear) {
    linearBtn.style.background = '#000';
    linearBtn.style.color = '#fff';
  }

  if (isRadial) {
    radialBtn.style.background = '#000';
    radialBtn.style.color = '#fff';
  }
};

const rotateGradient = (gradientStr, addDegrees) => {
    const regex = /linear-gradient\((\d+)deg,(.+)\)/;
    const match = gradientStr.match(regex);
    if (!match) return gradientStr;

    let currentDeg = parseInt(match[1], 10);
    let rest = match[2];
    const newDeg = (currentDeg + addDegrees) % 360;
    //console.log("newDeg", value);
    return `linear-gradient(${newDeg}deg,${rest.trim()})`;
  };
  const normalizeToTwoStops = (gradientStr) => {
  const regex = /(linear|radial)-gradient\(([^,]+),(.+)\)/i;
  const match = gradientStr.match(regex);
  if (!match) return gradientStr;

  const type = match[1];
  const angleOrPos = match[2].trim();
  const stopsRaw = match[3].trim();

  // Split on commas NOT inside parentheses (e.g., rgba)
  const stopRegex = /,(?![^(]*\))/g;
  const stops = stopsRaw.split(stopRegex).map(s => s.trim());

  if (stops.length <= 2) return gradientStr;

  // Keep original position percentages of first and last
  const first = stops[0];
  const last = stops[stops.length - 1];

  return `${type}-gradient(${angleOrPos}, ${first}, ${last})`;
};


  const handleColorChange = (newColor) => {
  
  if (typeof newColor === 'string') {
    const isRadial = newColor.startsWith('radial-gradient');
    const isLinear = newColor.startsWith('linear-gradient');

    if (isRadial || isLinear) {
      // Always treat as gradient regardless of same first/last stops
      const clamped = normalizeToTwoStops(newColor);
      setColor(clamped);
      setColorType('gradient');
      updateGradientTypeUI(clamped);
      if (onChange) onChange(clamped);
      return;
    }else{
      setColor(newColor);
      setColorType('solid');
      if (onChange) onChange(newColor);
    }

    // Not a gradient, treat as solid
    return;
  }

  // Fallback
  const fallbackColor = getRandomColor();
  setColor(fallbackColor);
  setColorType('solid');
  if (onChange) onChange(fallbackColor);
};


  return (
    <div className='color-picker-wrapper' >
      {/* Close Button */}
      <div className='picker-actions'>
        <button onClick={onClose} className='cancel-button'>×</button>
        <button
          onClick={() => {
            setSolid();
            const defaultSolid = getRandomColor();
            setColor(defaultSolid);
            setColorType('solid');
            if (onChange) onChange(defaultSolid);
          }}
          className={colorType === 'solid' ? 'active' : ''}
        >
          Solid
        </button>
        <button
          onClick={() => {
            setGradient();
            const defaultGradient = `linear-gradient(0deg, ${getRandomColor()} 0%, ${getRandomColor()} 100%)`;
            setColor(defaultGradient);
            setColorType('gradient');
            if (onChange) onChange(defaultGradient);
          }}
          className={colorType === 'gradient' ? 'active' : ''}
        >
          Gradient
        </button>
      </div>

      <GradientColorPicker 
       width={250}
        value={typeof color === 'string' ? color : getRandomColor()} 
        onChange={handleColorChange} 
        hidePresets 
        hideAdvancedSliders 
        hideColorGuide
        hideInputType
        hideGradientStop
        hideColorTypeBtns
      />
    </div>
  );
};

export default ColorPicker;
